import axios from 'axios';
import { getAccessToken, getRefreshToken, saveTokens, logout } from '@/lib/auth';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL, // напр. https://backend-field-turf.docuease.com
});

// ---- Request: подставляем Bearer access
api.interceptors.request.use((config) => {
  const access = getAccessToken();
  if (access) {
    config.headers.Authorization = `Bearer ${access}`;
  }
  return config;
});

// ---- Response: авто-рефреш при 401 (один ретрай)
let isRefreshing = false;
let pending = [];

function onRefreshed(newAccess) {
  pending.forEach((cb) => cb(newAccess));
  pending = [];
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (!response) return Promise.reject(error);

    if (response.status === 401 && !config.__isRetryRequest) {
      const refresh = getRefreshToken();
      if (!refresh) {
        logout();
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          pending.push((newAccess) => {
            if (!newAccess) reject(error);
            else {
              config.headers.Authorization = `Bearer ${newAccess}`;
              config.__isRetryRequest = true;
              resolve(api(config));
            }
          });
        });
      }

      try {
        isRefreshing = true;
        const resp = await axios.post(
          `${import.meta.env.VITE_API_BASE_URL}/api/auth/refresh/`,
          { refresh }
        );
        const newAccess = resp.data?.access;
        if (!newAccess) {
          logout();
          return Promise.reject(error);
        }
        saveTokens({ access: newAccess, refresh });
        onRefreshed(newAccess);

        config.headers.Authorization = `Bearer ${newAccess}`;
        config.__isRetryRequest = true;
        return api(config);
      } catch (e) {
        onRefreshed(null);
        logout();
        return Promise.reject(e);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;